'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var configureStore = void 0;

if (process.env.APPLICATION_MODE === 'electron') {
    configureStore = require('./configureStoreElectronClient').default;
} else {
    configureStore = require('./configureStoreWeb').default;
}

exports.default = configureStore;


//////////////////
// WEBPACK FOOTER
// ./src/client/store/configureStore.js
// module id = 2048
// module chunks = 0